<template>
  <el-dialog
    width="940px"
    top="30vh"
    :visible.sync="dialogCurrency"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    custom-class="code-dialog"
  >
    <div sort="title" class="code-title">{{ $t('product_code') }}</div>
    <div class="code-body">
      <p class="code-desc text-left" v-html=" $t('code_pratice_text', { paper_name: paperName, level_name: typeName.level_name }) "></p>
      <p class="code-desc black text-left">{{ $t('code_input_text') }}&nbsp;<span style="color: red;">({{ $t('use_code_limit') }})</span></p>
      <el-input v-model="code" :placeholder="$t('code_here')"></el-input>
      <p class="code-desc black mt-20 mb-10 text-left" v-if="codesLists.length > 0">
        {{ $t('code_select_text') }}
      </p>
      <ul class="max-h-120 overflow-auto text-left">
        <li
          v-for="item in codesLists"
          :key="item.id"
          @click="changeCode(item)"
          :class="item === code ? '!text-wohui-grey-2 !border-wohui-grey-2' : ''"
          class="inline-block mr-5 mb-5 px-5 h-35 leading-35 text-center text-wohui-grey-4 border border-solid border-wohui-grey-4 hover:text-wohui-grey-2 hover:border-wohui-grey-2 cursor-pointer"
        >
          {{ item }}
        </li>
      </ul>
      <div class="flex" style="margin: 32px 0 30px 0">
        <mui-button
          class="code-button"
          @click="useCode"
          :disabled="!code"
          type="yellow"
          size="large"
          :loading="loading"
          :loadingText="$t('loading')"
          >{{ $t('use_code') }}</mui-button
        >
      </div>
    </div>
    <div sort="footer" class="code-footer" v-if="partnerList.length > 0">
      <p class="code-footer-desc">{{ $t('no_code') }}</p>
      <div
        style="position: relative; margin-top: 12px"
        v-for="item in partnerList"
        :key="item.partner_id"
      >
        <p class="vimiss">{{ item.name }}</p>
        <div class="flex" style="position: absolute; top: 0px; right: 0px">
          <a :href="item.buy_url" class="partner" target="_blank">{{ $t('to_partner') }}</a
          ><SvgIcon type="arrow" style="width: 18px; height: 18px" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import { apiRequest } from '@/serves/http'
import analytics from '@/utils/AnalyticsCenter'
import { mapGetters } from 'vuex'
import { getCodesLists } from '@/serves/api/useCode'
export default {
  name: 'UseCode',
  components: {
    SvgIcon,
  },
  props: {
    nameTrans: {
      type: [String, Object],
      default: () => {},
    },
  },
  data() {
    return {
      dialogCurrency: false,
      code: '', // 当前选中的code
      codesLists: [], // code列表
      paperId: null,
      paperName: '',
      partnerList: [],
      loading: false,
      mLeftCodeTip: '',
      useDefaultCode: false,
    }
  },
  created() {
    this.getPartnerDetail()
  },
  computed: {
    ...mapGetters('level', {
      // 获取考试类型
      typeName: 'levelActiveObj',
      levelTypeName: 'levelTypeName',
    }),
  },
  filters: {
    filterPaperName: function (nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }
      return nameTrans[language]
    },
  },
  methods: {
    openDialog(paper_id, level_id, nameTrans) {

      let language = localStorage.getItem('language')
      console.log(this.nameTrans,language,'language_nameTrans')
      this.paperId = paper_id
      this.paperName = nameTrans[language]
      this.dialogCurrency = true
      this.code = ''

      if (!this.$store.state.user.isCodeUser && level_id) {
        this.getCodesList(level_id)
      }
    },
    closeDialog() {
      this.dialogCurrency = false
    },
    useCode() {
      let mixpanelParams = {
        paper_type: this.$options.filters['filterPaperName'](this.nameTrans),
        exam_type: this.typeName.level_name,
      }
      this.loading = true
      apiRequest
        .post(ApiPath.use_code, { code: this.code, paper_id: Number(this.paperId) })
        .then((res) => {
          Object.assign(mixpanelParams, { status: true })
          analytics.logEvent('hskweb_usecode2_click', mixpanelParams)
          this.dialogCurrency = false
          this.$emit('onOk')
          this.loading = false
        })
        .catch((err) => {
          Object.assign(mixpanelParams, { status: false })
          analytics.logEvent('hskweb_usecode2_click', mixpanelParams)
          this.loading = false
          this.$message.error(err)
        })
    },
    changeCode(item) {
      this.code = item
    },
    getPartnerDetail() {
      apiRequest
        .get(ApiPath.partnerDetail)
        .then((res) => {
          this.partnerList = res.data || []
        })
        .catch((err) => this.$message.error(err))
    },
    getCodesList(level_id) {
      getCodesLists({
        level_id: level_id,
      })
        .then((res) => {
          if (res?.data) {
            this.code = res?.data?.codes[0]
            this.codesLists = res?.data?.codes
            // this.mLeftCodeTip = this.$t('discount_codes_left_tip', {
            //   count: res.data?.code_count || 0,
            // })
            // this.mLeftCodeTip = this.$t('code_select_text')
          }
          this.useDefaultCode = this.code
        })
        .catch((err) => this.$message.error(err))
    },
  },
}
</script>

<style lang="scss" scoped>
.code-dialog {
  .code-title {
    color: #2c2f46;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    padding: 24px;
    border-bottom: 1px solid #e5e5e5;
  }

  .code-body {
    padding: 40px 190px;
    .code-desc {
      color: var(--Wohui-Grey-3, #b5b5be);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 10px;
      &.black {
        color: var(--Wohui-0, #2c2f46);
      }
    }
    ::v-deep .el-input__inner {
      height: 70px;
      border-radius: 4px;
      border: 3px solid var(--Wohui-Grey-4, #e7e7ed);
      font-family: Inter;
      font-size: 16px;
      font-weight: 700;
    }
    .code-button {
      width: 254px;
      height: 42px;
      border-radius: 4px;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      margin: 0 auto;
      word-break: break-word;
    }
  }
  .code-footer {
    padding: 20px 24px;
    background: #fafafb;
    .code-footer-desc {
      color: var(--Wohui-Grey-3, #b5b5be);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: center;
    }
    .partner {
      color: var(--Wohui-Sunshine, #faae56);
      text-align: right;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 17px;
      // border: 1px solid #192cbb;
    }
    .vimiss {
      color: #2c2f46;
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      text-align: center;
      // border: 1px solid #2c2f46;
    }
  }
}
</style>
